export default "__VITE_ASSET__d768dc54__"